/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, Suspense, useMemo, useRef } from "react";
import ScrollToTop from "../Utility/ScrollToTop/ScrollToTop";
import axiosIntegration from "../Common/Axios/axiosIntegration";
import {
  ApiConfigData,
  ApplyThemeStyles,
  ClientPlatformCode,
  GetMemberData,
  GetSegment,
  SectionContentMasterData,
  SectionMasterData,
  ThemeData,
  trackEvent,
  UserIdAndStatusData,
  UtilityReducer,
  ValidateLoginToken,
} from "../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import { onSaveCards, onSaveIamge } from "../Store/Slices/utilityReducer";
import API from "../Common/Endpoint/serviceConstrants";
import { useNavigate } from "react-router-dom";
import { onValidateLoginTokenResetNull } from "../Store/Slices/validateLoginTokenSlice";
import GetSectionByType from "./GetSectionByType";
import {
  onLandingHome,
  onLandingHomePostLogin,
} from "../Store/Slices/homePageLandingSlice";
import { onGetMemberData } from "../Store/Slices/getMemberSlice";
import { onSegmentReset, onSegmentSubmit } from "../Store/Slices/SegmentSlice";
import { onGetUnlockSection } from "../Store/Slices/unlockSectionSlice";
import { onGetThemeMaster } from "../Store/Slices/themeMasterSlice";
import Loader from "../Utility/Loader/Loader";
import CustomLoader3 from "../Utility/CustomLoader/CustomLoader_3";
import CustomLoader1 from "../Utility/CustomLoader/CustomLoader_1";
import { Helmet } from "react-helmet";
import getTranslation from "../TranslationUtility/TranslationUtility";

const Modal = React.lazy(() => import("../Components/Modal/Modal"));

const HomePage = ({
  setIsModalOpenoffer,
  isModalOpenoffer,
  setShowModal,
  setIsLoading,
  Loading,
  showModal,
  isMobileView,
}) => {
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const clientData = clientMasterData?.clientMasterData || [];

  const [sessionOut, setSetSessionOut] = useState(false);
  const homePageSlice = useSelector((state) => state.homePageSliceReducer);
  const card = UtilityReducer();
  const creditCards = card?.creditCards?.filter(card => card?.status === "1");
  const themeData = ThemeData();
  const [customeLoader, setCustomeLoader] = useState(homePageSlice?.customeLoader || true);
  const loginToken = useSelector(
    (state) => state.validateLoginTokenSliceReducer
  );
  const defaultCard = loginToken?.data?.subIdentifier;
  const unlockData = useSelector((state) => state?.unlockSectionReducer);
  const generateToken = useSelector((state) => state.generateTokenSliceReducer);
  const apiconfig = ApiConfigData();
  const navigate = useNavigate();
  const partnerCode = apiconfig?.find(
    (data) => data?.paramsKey === "partnerCode"
  )?.paramsValue;
  const clientCode = apiconfig?.find(
    (data) => data?.paramsKey === "clientCode"
  )?.paramsValue;
  const login = sessionStorage.getItem("login");
  const segmentData = GetSegment();
  const segments = useMemo(
    () => segmentData?.data?.[0]?.mappedSegment,
    [segmentData]
  );
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const dispatch = useDispatch();
  const { isSectionLoading, sectionMasterData } = SectionMasterData(login);
  const token = ValidateLoginToken();
  const { isLoading } = SectionContentMasterData();
  const { clientCode: clientPlatformCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();

  const [accountData, setAccountData] = useState([]);
  const [apiError, setApiError] = useState(false);
  const fetchedAccountIdsRef = useRef(new Set());
  let cusLoader = sessionStorage.getItem("customLoader")
  const postLoginSuccesCount = sessionStorage.getItem("postLoginSuccesCount");
  useEffect(() => {
    if (cusLoader) {
      setCustomeLoader(true);
    }
  }, [cusLoader]);

  const callSwitchAccountApi = async (payload) => {
    try {
      // avoid duplicate requests for the same subIdentifier
      if (fetchedAccountIdsRef.current.has(payload?.subIdentifier)) {
        return null;
      }

      if (!generateToken?.data?.accessToken) {
        console.error("Access token is missing");
        return null;
      }

      axiosIntegration.defaults.headers["access-token"] =
        generateToken.data.accessToken;

      const { data = [] } = await axiosIntegration.post(
        API.switchAccountApi,
        payload,
        {
          headers: {
            clientCode: clientCode,
            partnerCode: partnerCode,
          },
        }
      );

      // add response only if not already present
      setAccountData((prevData) => {
        const exists = prevData?.some(
          (d) => d?.response?.subIdentifier === data?.response?.subIdentifier
        );
        if (exists) return prevData;
        return [...prevData, data];
      });

      // mark this subIdentifier as fetched
      if (payload?.subIdentifier) {
        fetchedAccountIdsRef.current.add(payload.subIdentifier);
      }

      setApiError(false);
      return data;
    } catch (error) {
      setApiError(true);
      return null;
    }
  };
  const memberData = GetMemberData();
  const cards = memberData?.otherListAttribute
    ?.filter((cardData) => cardData?.valueIndetifier === "CardDetails")
    ?.flatMap((cardData) => cardData?.valueDetails)
    ?.filter((cardData) => cardData.status !== "0");

  const finalCredicards = cards?.filter(
    (card) => card?.identifiertype === "1002"
  );
  const finalDebitcards = cards?.filter(
    (card) => card?.identifiertype === "1001"
  );

  const toTop = sessionStorage.getItem("toTop");
  useEffect(() => {
    if (toTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        sessionStorage.removeItem("toTop");
      }, 5000);
    }
  }, [toTop, sectionMasterData]);

  // Use a ref to prevent duplicate API calls on fast rerenders
  const hasFetched = useRef(false);

  useEffect(() => {
    // Only fetch if not already fetched for these segments
    let persistedData = JSON.parse(sessionStorage?.getItem("persist:root"));
    const homepageOldData = persistedData ? JSON.parse(persistedData?.homePageSliceReducer) : {};

    let postLoginSuccesCount = sessionStorage.getItem("postLoginSuccesCount");

    if (!postLoginSuccesCount) {
      sessionStorage.setItem("postLoginSuccesCount", 1);
    }

    if (loginAuthData?.data && !hasFetched.current) {
      hasFetched.current = true; // Mark as fetched
      if (token?.memberIdentifier) {
        // homepageData is now an object, not an array
        if (!homepageOldData?.homePageData || (typeof homepageOldData?.homePageData === "object" && Object.keys(homepageOldData?.homePageData).length === 0)) {
          dispatch(onLandingHome());
          setIsLoading(true);
          // Do not call post-login here, wait for landing home success
        } else {
        }
      }
      else {
        // homepageData is now an object, not an array
        if (
          !homepageOldData?.homePageData ||
          (typeof homepageOldData?.homePageData === "object" &&
            Object.keys(homepageOldData?.homePageData).length === 0)
        ) {
          if (!login) {
            dispatch(onLandingHome());
          }
        }
      }
    }

    setIsLoading(false);
    setIsModalOpenoffer(false);

  }, [
    segments,
    loginAuthData?.data,
    token?.memberIdentifier,
    dispatch,
    setIsLoading,
    setIsModalOpenoffer,
    homePageSlice,
  ]);

  // Listen for landing home success and trigger post-login if needed
  useEffect(() => {
    let postloginCall = sessionStorage.getItem("postLoginTriggered");
    let delayTimer;
    if (postloginCall && token?.memberIdentifier && homePageSlice?.status_code === "200") {
      // Find the object with valueIndetifier === 'CardDetails'
      const cardDetailsObj = token?.otherListAttribute?.find(
        (item) => item?.valueIndetifier === "CardDetails"
      );
      const cardCodeValue = [
        ...new Set(
          cardDetailsObj?.valueDetails
            ?.filter(card => card.status === "1" || card.status === "2")
            ?.map(card => card.CardTypeName?.toLowerCase()).filter(Boolean)
        )
      ] || [];
      const cardsNetwork = [
        ...new Set(
          cardDetailsObj?.valueDetails
            ?.filter(card => card.status === "1" || card.status === "2")
            ?.map(card => card.Network?.toLowerCase()).filter(Boolean)
        )
      ] || [];
      dispatch(onLandingHomePostLogin({ memberIdentifier: token?.memberIdentifier, cardCode: encodeURIComponent(cardCodeValue.join(", ")), cardsNetwork: encodeURIComponent(cardsNetwork.join(", ")) }));
    }

    return () => {
      if (delayTimer) clearTimeout(delayTimer);
    };

  }, [homePageSlice?.status_code, token?.memberIdentifier, dispatch]);

  useEffect(() => {
    if (!themeData && homePageSlice?.status_code === "200") {
      dispatch(onGetThemeMaster({
        data: homePageSlice?.homePageData?.themeManagement,
        status_code: homePageSlice?.status_code,
      }));
    }
    ApplyThemeStyles(themeData);
  }, [themeData, homePageSlice?.status_code]);

  useEffect(() => {
    const handleBodyOverflow = () => {
      const isModalOpen = isModalOpenoffer;
      document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    };

    handleBodyOverflow();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);
  useEffect(() => {
    const hasRun = sessionStorage.getItem("setCard");
    const setCardBalance = sessionStorage.getItem("setCardBalance");
    if (login && !hasRun && creditCards?.length && setCardBalance) {

      const finalCredicards = creditCards?.filter(
        (card) => card?.identifiertype === "1002"
      );
      const finalDebitcards = creditCards?.filter(
        (card) => card?.identifiertype === "1001"
      );

      const allCards = [...finalCredicards, ...finalDebitcards];
      const getCardData = () => {
        const defaultCardData = allCards.find(
          (card) => card?.identifier === defaultCard
        );
        trackEvent("default_card", {
          card_name: defaultCardData ? defaultCardData.CardTypeName : (finalCredicards.length ? finalCredicards[0]?.CardTypeName : finalDebitcards[0]?.CardTypeName),
          points: defaultCardData ? 
            defaultCardData.pointBalance || 0 : (finalCredicards.length ? finalCredicards[0]?.pointBalance || 0 : finalDebitcards[0]?.pointBalance || 0),
          client_code: clientPlatformCode,
          platform_code: platformCode,
          user_id: userId,
          user_status: userStatus,
          page_url: window.location.href,
        });
        if (defaultCardData) return defaultCardData;

        return finalCredicards.length ? finalCredicards[0] : finalDebitcards[0];
      };

      const cardData = getCardData();
      if (cardData) {
        dispatch(
          onSaveIamge({
            currentBg: cardData.backgroundcolor,
            currentPoints: cardData.pointBalance,
            cardName: cardData.CardTypeName,
            totalPointBalance: cardData.totalPointBalance,
            showTryAgain: false,
            showViewPoint: false,
          })
        );
      }

      sessionStorage.setItem("setCard", "true");
    }
  }, [login, card]);

  useEffect(() => {
    if (!loginToken?.isUsed && login) {
      let timeoutId;

      const payload = {
        sessionToken: loginToken?.data?.partnerSessinToken,
      };

      const callKeepSessionAlive = async (payloads) => {
        axiosIntegration.defaults.headers[
          "access-token"
        ] = `${generateToken?.data?.accessToken}`;

        try {
          const response = await axiosIntegration.post(
            API.keepAlive,
            payloads,
            {
              headers: {
                clientCode: clientCode,
                partnerCode: partnerCode,
              },
            }
          );

          if (response.status === 200) {
            timeoutId = setTimeout(
              () => callKeepSessionAlive(payloads),
              240000
            );
          }

          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            localStorage.clear();
            setSetSessionOut(true);
            navigate("/");
          }
          console.error("API call failed:", error);
        }
      };

      if (loginToken && loginToken.data.partnerSessinToken) {
        dispatch(onValidateLoginTokenResetNull());
        callKeepSessionAlive(payload);
      }

      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    }
  }, [loginToken]);

  // Fetch card data when post-login API call is successful
  useEffect(() => {
    if (
      homePageSlice?.status_code === "200" &&
      homePageSlice?.post_login_success
    ) {
      dispatch(
        onSegmentSubmit({
          data: homePageSlice?.homePageData?.segmentMappings,
          status_code: homePageSlice?.status_code,
        })
      );
      dispatch(
        onGetUnlockSection({
          data: homePageSlice?.homePageData?.unlockSectionActivities,
          status_code: homePageSlice?.status_code,
          homepage: true
        })
      );
      dispatch(onGetThemeMaster({
        data: homePageSlice?.homePageData?.themeManagement,
        status_code: homePageSlice?.status_code,
      }));

      const fetchCardData = (cardsList) => {
        const toFetch = cardsList.filter(
          (card) => !fetchedAccountIdsRef.current.has(card?.identifier)
        );

        return toFetch.map((cardData) =>
          callSwitchAccountApi({
            identifier: loginToken?.data?.memberIdentifier,
            subIdentifier: cardData?.identifier,
            identifierType: parseInt(cardData?.identifiertype),
            userSessionToken: sessionStorage.getItem("temporaryToken"),
            isAccountSwitch: false,
          })
        );
      };

      const allCards = [...finalCredicards, ...finalDebitcards];

      const defaultCardExists = allCards.find(
        (card) => card?.identifier === defaultCard
      );

      const targetCards = defaultCardExists ? [defaultCardExists] : finalCredicards.length ? [finalCredicards[0]] : [finalDebitcards[0]];

      const cardPromises = fetchCardData(targetCards);

      if (!cardPromises.length) {
        // Nothing new to fetch
        setIsLoading(false);
        setTimeout(() => {
          setCustomeLoader(false);
        }, 800);
        dispatch(onSegmentReset());
      } else {
        Promise.all(cardPromises).then(() => {
          setIsLoading(false);
          setTimeout(() => {
            setCustomeLoader(false)
          }, 800); // Delay to ensure UI updates
          dispatch(onSegmentReset());
        }).catch(() => {
          // Ensure loader resets even if some requests failed
          setIsLoading(false);
          setTimeout(() => {
            setCustomeLoader(false)
          }, 800);
          dispatch(onSegmentReset());
        });
      }

    }

  }, [homePageSlice?.status_code, homePageSlice?.post_login_success]);

  useEffect(() => {
    if (accountData?.length > 0) {
      const creditCards = cards?.map((card, index) => {
        const matchingAccount = accountData?.find(
          (account) => account.response.subIdentifier === card.identifier
        );
        return {
          ...card,
          pointBalance: matchingAccount?.response?.memberBalance?.pointBalance,
          totalPointBalance: matchingAccount?.response?.memberBalance?.totalPointBalance,
          showViewPoint: false,
          showTryAgain:
            (defaultCard !== null &&
              defaultCard !== "" &&
              defaultCard === card.identifier &&
              apiError) ||
            (index === 0 && apiError),
        };
      })

      dispatch(onSaveCards({
        creditCards: creditCards,
        debitCards: cards?.filter((card) => card?.identifiertype === "1001"),
        excludeCards: cards?.filter((card) => card?.state === "2"),
      })
      );
      sessionStorage.setItem("setCardBalance", "true");
    } else {
      dispatch(onSaveCards({
        creditCards: cards,
        debitCards: cards?.filter((card) => card?.identifiertype === "1001"),
        excludeCards: cards?.filter((card) => card?.state === "2"),
      })
      );
    }
  }, [accountData])

  useEffect(() => {
    if (loginToken?.status_code === "400" || loginToken?.status_code === '401' || loginToken?.status_code === 401 || loginToken?.status_code === 400 || loginToken?.status_code === 404) {
      if (loginToken?.message) {
        sessionStorage.clear();
        localStorage.clear();
        setSetSessionOut(true);
        // clear any tracked fetched accounts when session ends
        if (fetchedAccountIdsRef?.current) fetchedAccountIdsRef.current.clear();
        setAccountData([]);
      } else {
        sessionStorage.clear();
        localStorage.clear();
        setSetSessionOut(true);
        if (fetchedAccountIdsRef?.current) fetchedAccountIdsRef.current.clear();
        setAccountData([]);
      }
      navigate("/");
    }
  }, [loginToken])

  const translation = getTranslation();

  // Ensure meta description is always available
  const metaDescription = translation?.homeDescription || "Welcome to our rewards platform where you can earn and redeem points";
  const metaTitle = translation?.homeTitle || "Home - Rewards Platform";

  useEffect(() => {
    const thresholds = [10, 25, 50, 75, 100];
    let sent = {};
    thresholds.forEach(t => sent[t] = false);
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const pageDepth = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
      thresholds.forEach((threshold) => {
        if (pageDepth >= threshold && !sent[threshold]) {
          trackEvent("scroll_depth", {
            page_name: "Home Page",
            page_url: window.location.href,
            scroll_percent: threshold
          });
          sent[threshold] = true;
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={login && !Loading && sectionMasterData?.length > 0 && !customeLoader ? "home-page-bg" : ""}>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      {sessionOut && !login && (
        <Suspense fallback={<Loader />}>
          <Modal
            title="For security purposes, your session has timed out. Please click OK to log in again"
            button={true}
          />
        </Suspense>
      )}
      <ScrollToTop />
      {!login ? (<>
        {isLoading || Loading || isSectionLoading ? <Loader /> :
          (sectionMasterData?.map((sectionData, index) => (
            <GetSectionByType
              sectionData={sectionData}
              isLogin={login}
              setIsModalOpenoffer={setIsModalOpenoffer}
              isModalOpenoffer={isModalOpenoffer}
              setShowModal={setShowModal}
              setIsLoading={setIsLoading}
              Loading={Loading}
              showModal={showModal}
              unlockData={unlockData}
              isMobileView={isMobileView}
            />
          )))
        }
      </>) : (<>
        <div>
          {login && !customeLoader ? sectionMasterData?.map((sectionData, index) => (
            <div className={isMobileView && login ? "animation-section" : ""} key={`section-${index}-id${sectionData?.id}-name${sectionData?.sectionName}`}>
              <GetSectionByType
                sectionData={sectionData}
                isLogin={login}
                setIsModalOpenoffer={setIsModalOpenoffer}
                isModalOpenoffer={isModalOpenoffer}
                setShowModal={setShowModal}
                setIsLoading={setIsLoading}
                Loading={Loading}
                showModal={showModal}
                unlockData={unlockData}
                isMobileView={isMobileView}
                setCustomeLoader={setCustomeLoader}
              />
            </div>
          )) : clientData[0]?.loaderConfiguration && clientData[0]?.loaderConfiguration?.loaderType?.toLowerCase() === "custom" && postLoginSuccesCount === "1" && customeLoader ? <CustomLoader3 /> : <Loader />}
        </div>
      </>)}
    </div>
  );
};

export default HomePage;
